import React, {useEffect, useState} from "react";
import axios from "axios";

const NieuweMachine = () => {
    const [Machines, setMachines] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [formData, setFormData] = useState({
        organization: 'first',
        influx_Serienummer: '',
        machine_Serienummer: '',

        macaddress: '',

        machine_Model: '',
        machine_Merk: '',
        machine_Naam: '',

        hulpstuk: '',
        hulpstuknummer: '',
        hulpstukken: [],

        hulpstuk_machine: 'first',
        dbc_machine: 'first',
    });

    useEffect(() => {
        const fetchOrganizations = async () => {
            const response = await axios.get(`/api/organization/get/electric`);

            await setOrganizations(response.data);
        };

        const fetchMachines = async () => {
            const response = await axios.get(`/api/machine/get/all`);

            await setMachines(response.data);
        };

        fetchMachines()
        fetchOrganizations()
    }, [])

    const getMachineHulpstukken = async () => {
        const response = await axios.get(`/api/machine/get`, {
            params: {
                merk: formData.hulpstuk_machine,
            }
        })

        formData.hulpstukken = []

        for (const hulpstuk in response.data.hulpstukken) {
            if (response.data.hulpstukken[hulpstuk].naam !== "") {
                formData.hulpstukken.push([response.data.hulpstukken[hulpstuk].naam, response.data.hulpstukken[hulpstuk].nummer])
            }
            setFormData({
                ...formData
            });
        }
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleChangeList = () => {
        if (formData.hulpstuk !== '') {
            setFormData({
                ...formData,
                hulpstukken: [...formData.hulpstukken, [formData.hulpstuk, parseInt(formData.hulpstuknummer)]],
                hulpstuk: '',
                hulpstuknummer: 0,
            });
        }
    };

    const deleteHulpstuk = (index) => {
        setFormData({
            ...formData,
            hulpstukken: formData.hulpstukken.filter((_, i) => i !== index)
        });
    };

    const DownloadConfig = async () => {
        const response = await axios.get(`/api/machine/config/download`, {
            params: {
                serienummer: formData.machine_Serienummer,
            }
        })

        const blob = new Blob([response.data], { type: 'application/xml' })
        const blobUrl = URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = blobUrl
        a.download = "config.xml"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        URL.revokeObjectURL(blobUrl)
    }

    const CreateConfig = async () => {
        const response = await axios.get(`/api/machine/config/create`, {
            params: {
                bedrijf: formData.organization,
                serienummer: formData.machine_Serienummer,
                dbcserienummer: formData.dbc_machine.split(' ').slice(1).join(' ')
            }
        })

        console.log(response)
    }

    const CreateWriter = async () => {
        const response = (await axios.get("/api/machine/writer/create", {
            params: {
                bedrijf: formData.organization,
                serienummer: formData.machine_Serienummer,
                influxserienummer: formData.influx_Serienummer,
                dbcserienummer: formData.dbc_machine.split(' ').slice(1).join(' '),
            }
        })).data;

        console.log(response);
    }

    const CreateMongoose = async () => {
        await axios.get(`/api/machine/create`, {
            params: {
                brand: formData.machine_Merk,
                hulpstukken: formData.hulpstukken,
                alias: formData.machine_Naam,
                model: formData.machine_Model,
                bedrijf: formData.organization,
                cleanorg: organizations.find(element => element.name === formData.organization).clean,
                macaddress: formData.macaddress,
                machine_serial: formData.machine_Serienummer,
                influx_serial: formData.influx_Serienummer,
                dbc_machine: formData.dbc_machine,
            }
        });
    }

    const Nieuw = async (e) => {
        e.preventDefault();
        if (!Machines.find(element => element.serialNumber === formData.machine_Serienummer)) {
            try {
                await CreateMongoose();
                await CreateWriter();
                await CreateConfig();
                await DownloadConfig();
            } catch (error) {
                console.error('Error in Nieuw function:', error);
            }
        }
    };

    const formList = ["influx_Serienummer", "machine_Serienummer", "machine_Merk", "machine_Naam", "machine_Model"]

    return (
        <div className={"pl-14 pr-14 flex flex-col gap-10 p-2"}>
            <div className="flex gap-10">
                <dialog id={"loading"} open className={"top-52 z-50 text-center text-9xl p-10 rounded-lg shadow-xl bg-white select-none hidden flex-col gap-10"}>
                    Laden...
                    <h1 className={"text-2xl"}>dit kan even duren</h1>
                </dialog>
                <div className="flex w-2/6 flex-col items-center gap-5 bg-white rounded-md shadow-lg p-8">
                    <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>Maak Een Nieuwe Machine</h1>
                    <form id={"form"} className="flex flex-col items-center gap-4 rounded-md justify-center w-full">
                        <div className="w-full flex flex-col gap-1">
                            <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Organisatie</h1>
                            <select className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" onChange={handleChange} name={"organization"} value={formData.organization}>
                                <option disabled={true} hidden={true} value="first">Kies Een Organisatie</option>
                                {organizations.map((organization) => (
                                    <option className={"text-gray-500 text-xl"} key={organization._id} value={organization.name}>
                                        {organization.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {formList.map((name) => (
                            <div className="w-full flex flex-col gap-1" key={name}>
                                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>{name.toLocaleUpperCase()[0] + name.slice(1).replace("_", " ")}</h1>
                                <input
                                    className="w-full text-xl p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal"
                                    type="text"
                                    placeholder={"Vul " + name.toLocaleUpperCase()[0] + name.slice(1).replace("_", " ") + " In"}
                                    name={name}
                                    value={formData[name]}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        ))}
                        <div className="w-full flex flex-col gap-1">
                            <h1 className="text-gray-600 pl-1 text-xl font-medium">Vergelijkbare Machine</h1>
                            <select className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" onChange={handleChange} name={"dbc_machine"} value={formData.dbc_machine}>
                                <option disabled={true} hidden={true} value="first">Kies Een Vergelijkbare Machine</option>
                                {Machines.map((machine) => (
                                    <option className={"text-gray-500 text-xl"} key={machine._id || machine.brand} value={machine.brand + " " + machine.alias}>
                                        {machine.brand + " " + machine.model}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button onClick={Nieuw} className="w-fit text-2xl text-center rounded-md py-2 px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer">
                            Maak Machine
                        </button>
                    </form>
                </div>

                <div className="flex flex-col w-1/4 gap-5">
                    <div className="flex flex-col gap-5 bg-white rounded-md shadow-lg p-8">
                        <div className="w-full flex flex-col gap-1">
                            <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Mac-Adress</h1>
                            <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="text" placeholder="000 00 AS0 A0000" name="macaddress" value={formData.macaddress} onChange={handleChange} required/>
                        </div>
                    </div>

                    <div className="flex flex-col items-center gap-5 bg-white rounded-md shadow-lg justify-center p-8">
                        <div className="w-full flex flex-col gap-1">
                            <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Kies een machine voor hulpstukken</h1>
                            <select className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" onChange={handleChange} name={"hulpstuk_machine"} value={formData.hulpstuk_machine}>
                                <option disabled={true} hidden={true} value="first">Selecteer Machine Voor Hulpstukken</option>
                                {Machines.map((machine) => (
                                    <option className={"text-gray-500 text-xl"} key={machine._id || machine.brand} value={machine.brand + " " + machine.alias}>
                                        {machine.brand + " " + machine.model}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <input
                            className="w-fit text-2xl text-center rounded-md py-2 px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"
                            type="button" value="Importeer" onClick={getMachineHulpstukken}
                        />
                    </div>

                    <div className="flex flex-col gap-5 bg-white rounded-md shadow-lg p-8">
                        <a href={"/machine/handleiding"} className={"w-full text-2xl text-center rounded-md py-2 self-center px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"}>Handleiding</a>
                    </div>
                </div>

                <div className="flex flex-col gap-5 w-5/12 h-full">
                    <div className="flex w-full h-[610px] grow flex-col items-center gap-5 bg-white rounded-md shadow-lg justify-center p-8">
                        <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>Hulpstuk Lijst</h1>
                        <ul className="flex flex-col gap-4 w-full h-full overflow-y-scrollbar relative overflow-auto grow">
                            {formData.hulpstukken.length > 0 ? formData.hulpstukken.map((hulpstukken, index) => (
                                <li key={index} className="w-full flex text-xl text-gray-300 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal">
                                    <h1 className="text-gray-700 w-3/5 select-none">{hulpstukken[0]}</h1>
                                    <h1 className="text-gray-700 w-2/5 select-none">{hulpstukken[1]}</h1>
                                    <img onClick={() => deleteHulpstuk(index)} className="absolute right-3 h-8 w-7 hover:cursor-pointer" src="/delete.svg" alt="delete"/>
                                </li>
                            )): ""}
                        </ul>
                    </div>

                    <div className="flex w-full flex-col gap-5 bg-white rounded-md shadow-lg p-8">
                        <div className="w-full flex gap-2">
                            <div className="w-4/5 flex flex-col gap-1">
                                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Hulpstuk Naam</h1>
                                <input className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal" type="text" placeholder="Nieuw Hulpstuk" name="hulpstuk" value={formData.hulpstuk} onChange={handleChange} required/>
                            </div>
                            <div className="w-1/5 flex flex-col gap-1">
                                <h1 className={"text-gray-600 pl-1 text-xl font-medium"}>Nummer</h1>
                                <input placeholder={"0"} className="w-full text-xl text-gray-600 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600 border leading-normal" type="number" name="hulpstuknummer" value={formData.hulpstuknummer} onChange={handleChange} required/>
                            </div>
                        </div>

                        <input
                            className="w-fit text-2xl text-center rounded-md py-2 self-center px-6 bg-orange-500 text-white shadow-xl hover:cursor-pointer"
                            onClick={handleChangeList}
                            value="Voeg Hulpstuk Toe"
                            type="button"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NieuweMachine;